import * as yup from 'yup';

import { AuthMethods } from '../constants';

export const emailValidationSchema = yup.object({
  email: yup
    .string()
    .email('Please enter a valid email address')
    .required('Please enter a valid email address'),
});

export const getAuthType = (loginMethod?: AuthMethods): string => {
  switch (loginMethod) {
    case AuthMethods.GOOGLE:
      return 'Google';
    case AuthMethods.FACEBOOK:
      return 'Facebook';
    case AuthMethods.PASSWORD:
      return 'Password';
    case AuthMethods.GOOGLE_ONE_TAP:
      return 'Google One Tap';
    default:
      return '';
  }
};
